export const SELF_GUIDED_TRIP_START = "SELF_GUIDED_TRIP_START";
export const SELF_GUIDED_TRIP_SUCCESS = "SELF_GUIDED_TRIP_SUCCESS";
export const SELF_GUIDED_TRIP_ERROR = "SELF_GUIDED_TRIP_ERROR";

export const SELF_GUIDED_TRIP_DETAIL_START = "SELF_GUIDED_TRIP_DETAIL_START";
export const SELF_GUIDED_TRIP_DETAIL_SUCCESS =
  "SELF_GUIDED_TRIP_DETAIL_SUCCESS";
export const SELF_GUIDED_TRIP_DETAIL_ERROR = "SELF_GUIDED_TRIP_DETAIL_ERROR";

export const HEADER_DATA_START = "HEADER_DATA_START";
export const HEADER_DATA_SUCCESS = "HEADER_DATA_SUCCESS";
export const HEADER_DATA_ERROR = "HEADER_DATA_ERROR";

export const FOOTER_DATA_START = "FOOTER_DATA_START";
export const FOOTER_DATA_SUCCESS = "FOOTER_DATA_SUCCESS";
export const FOOTER_DATA_ERROR = "FOOTER_DATA_ERROR";

export const RIDE_NEAR_ME_DATA_START = "RIDE_NEAR_ME_DATA_START";
export const RIDE_NEAR_ME_DATA_SUCCESS = "RIDE_NEAR_ME_DATA_SUCCESS";
export const RIDE_NEAR_ME_DATA_ERROR = "RIDE_NEAR_ME_DATA_ERROR";

export const GET_GST_DETAIL_START = "GET_GST_DETAIL_START";
export const GET_GST_DETAIL_SUCCESS = "GET_GST_DETAIL_SUCCESS";
export const GET_GST_DETAIL_ERROR = "GET_GST_DETAIL_ERROR";

export const STORE_GST_DETAIL_START = "STORE_GST_DETAIL_START";
export const STORE_GST_DETAIL_SUCCESS = "STORE_GST_DETAIL_SUCCESS";
export const STORE_GST_DETAIL_ERROR = "STORE_GST_DETAIL_ERROR";

export const GET_PINCODE_START = "GET_PINCODE_START";
export const GET_PINCODE_SUCCESS = "GET_PINCODE_SUCCESS";
export const GET_PINCODE_ERROR = "GET_PINCODE_ERROR";

export const SEARCH_CUSTOMER_START = "SEARCH_CUSTOMER_START";
export const SEARCH_CUSTOMER_SUCCESS = "SEARCH_CUSTOMER_SUCCESS";
export const SEARCH_CUSTOMER_ERROR = "SEARCH_CUSTOMER_ERROR";

export const CUSTOMER_REVIEWS_START = "CUSTOMER_REVIEWS_START";
export const CUSTOMER_REVIEWS_SUCCESS = "CUSTOMER_REVIEWS_SUCCESS";
export const CUSTOMER_REVIEWS_ERROR = "CUSTOMER_REVIEWS_ERROR";

export const CUSTOMER_TOKEN_START = "CUSTOMER_TOKEN_START";
export const CUSTOMER_TOKEN_SUCCESS = "CUSTOMER_TOKEN_SUCCESS";
export const CUSTOMER_TOKEN_ERROR = "CUSTOMER_TOKEN_ERROR";

export const ADD_TO_CART_START = "ADD_TO_CART_START";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_ERROR = "ADD_TO_CART_ERROR";
export const BOOKING_RIDER_DETAILS_START = "BOOKING_RIDER_DETAILS_START";
export const BOOKING_RIDER_DETAILS_SUCCESS = "BOOKING_RIDER_DETAILS_SUCCESS";
export const BOOKING_RIDER_DETAILS_ERROR = "BOOKING_RIDER_DETAILS_ERROR";

export const LIST_OF_MOTORCYCLE_START = "LIST_OF_MOTORCYCLE_START";
export const LIST_OF_MOTORCYCLE_SUCCESS = "LIST_OF_MOTORCYCLE_SUCCESS";
export const LIST_OF_MOTORCYCLE_ERROR = "BOOKING_RIDER_DETAILS_ERROR";

export const BOOKING_SUMMARY_FOR_CART_START = "BOOKING_SUMMARY_FOR_CART_START";
export const BOOKING_SUMMARY_FOR_CART_SUCCESS =
  "BOOKING_SUMMARY_FOR_CART_SUCCESS";
export const BOOKING_SUMMARY_FOR_CART_ERROR = "BOOKING_SUMMARY_FOR_CART_ERROR";

export const CONFIRM_ADDRESS_START = "CONFIRM_ADDRESS_START";
export const CONFIRM_ADDRESS_SUCCESS = "CONFIRM_ADDRESS_SUCCESS";
export const CONFIRM_ADDRESS_ERROR = "CONFIRM_ADDRESS_ERROR";

export const FETCH_ADDRESS_START = "FETCH_ADDRESS_START";
export const FETCH_ADDRESS_SUCCESS = "FETCH_ADDRESS_SUCCESS";
export const FETCH_ADDRESS_ERROR = "FETCH_ADDRESS_ERROR";

export const VAS_BOOKING_LIST_START = "VAS_BOOKING_LIST_START";
export const VAS_BOOKING_LIST_SUCCESS = "VAS_BOOKING_LIST_SUCCESS";
export const VAS_BOOKING_LIST_ERROR = "VAS_BOOKING_LIST_ERROR";

export const CHECK_RIDER_LIST_START = "CHECK_RIDER_LIST_START";
export const CHECK_RIDER_LIST_SUCCESS = "CHECK_RIDER_LIST_SUCCESS";
export const CHECK_RIDER_LIST_ERROR = "CHECK_RIDER_LIST_ERROR";

export const RECOMMENDED_BIKES_START = "RECOMMENDED_BIKES_START";
export const RECOMMENDED_BIKES_SUCCESS = "RECOMMENDED_BIKES_SUCCESS";
export const RECOMMENDED_BIKES_ERROR = "RECOMMENDED_BIKES_ERROR";

export const RECOMMENDED_RIDES_START = "RECOMMENDED_RIDES_START";
export const RECOMMENDED_RIDES_SUCCESS = "RECOMMENDED_RIDES_SUCCESS";
export const RECOMMENDED_RIDES_ERROR = "RECOMMENDED_RIDES_ERROR";

export const BOOKING_ITEM_DELETE_START = "BOOKING_ITEM_DELETE_START";
export const BOOKING_ITEM_DELETE_SUCCESS = "BOOKING_ITEM_DELETE_SUCCESS";
export const BOOKING_ITEM_DELETE_ERROR = "BOOKING_ITEM_DELETE_ERROR";

export const BOOKING_ALL_ITEM_DELETED_START = "BOOKING_ALL_ITEM_DELETED_START";
export const BOOKING_ALL_ITEM_DELETED_SUCCESS = "BOOKING_ALL_ITEM_DELETED_SUCCESS";
export const BOOKING_ALL_ITEM_DELETED_ERROR = "BOOKING_ALL_ITEM_DELETED_ERROR";

export const OPERATOR_LIST_START = "OPERATOR_LIST_START";
export const OPERATOR_LIST_SUCCESS = "OPERATOR_LIST_SUCCESS";
export const OPERATOR_LIST_ERROR = "OPERATOR_LIST_ERROR";


export const LANDING_AEM_START = "LANDING_AEM_START";
export const LANDING_AEM_SUCCESS = "LANDING_AEM_SUCCESS";
export const LANDING_AEM_ERROR = "LANDING_AEM_ERROR";

export const RECOMMENDED_PRODUCT_START = "RECOMMENDED_PRODUCT_START";
export const RECOMMENDED_PRODUCT_SUCCESS = "RECOMMENDED_PRODUCT_SUCCESS";
export const RECOMMENDED_PRODUCT_ERROR = "RECOMMENDED_PRODUCT_ERROR";
export const APPLY_COUPON_CODE_START = "APPLY_COUPON_CODE_START";
export const APPLY_COUPON_CODE_SUCCESS = "APPLY_COUPON_CODE_SUCCESS";
export const APPLY_COUPON_CODE_ERROR = "APPLY_COUPON_CODE_ERROR";

export const PAYMENT_INFORMATION_START = "PAYMENT_INFORMATION_START";
export const PAYMENT_INFORMATION_SUCCESS = "PAYMENT_INFORMATION_SUCCESS";
export const PAYMENT_INFORMATION_ERROR = "PAYMENT_INFORMATION_ERROR";

export const ORDER_SUCCESS_DETAILS_START = "ORDER_SUCCESS_DETAILS_START";
export const ORDER_SUCCESS_DETAILS_SUCCESS = "ORDER_SUCCESS_DETAILS_SUCCESS";
export const ORDER_SUCCESS_DETAILS_ERROR = "ORDER_SUCCESS_DETAILS_ERROR";

export const SELF_GUIDED_TRIP_LONG_RIDES_START = "SELF_GUIDED_TRIP_LONG_RIDES_START";
export const SELF_GUIDED_TRIP_LONG_RIDES_SUCCESS = "SELF_GUIDED_TRIP_LONG_RIDES_SUCCESS";
export const SELF_GUIDED_TRIP_LONG_RIDES_ERROR = "SELF_GUIDED_TRIP_LONG_RIDES_ERROR";

export const SELF_GUIDED_TRIP_TRAILS_START = "SELF_GUIDED_TRIP_TRAILS_START";
export const SELF_GUIDED_TRIP_TRAILS_SUCCESS = "SELF_GUIDED_TRIP_TRAILS_SUCCESS";
export const SELF_GUIDED_TRIP_TRAILS_ERROR = "SELF_GUIDED_TRIP_TRAILS_ERROR";

export const USER_RIDE_NEAR_ME_DATA_START = "USER_RIDE_NEAR_ME_DATA_START";
export const USER_RIDE_NEAR_ME_DATA_SUCCESS = "USER_RIDE_NEAR_ME_DATA_SUCCESS";
export const USER_RIDE_NEAR_ME_DATA_ERROR = "USER_RIDE_NEAR_ME_DATA_ERROR";

export const ADD_RETING_DATA_START = "ADD_RETING_DATA_START";
export const ADD_RETING_DATA_SUCCESS = "ADD_RETING_DATA_SUCCESS";
export const ADD_RETING_DATA_ERROR = "ADD_RETING_DATA_ERROR";

export const GET_SECOND_PINCODE_SUCCESS = "GET_SECOND_PINCODE_SUCCESS";

export const OUT_OF_STOCK_START = "OUT_OF_STOCK_START";
export const OUT_OF_STOCK_SUCCESS = "OUT_OF_STOCK_SUCCESS";
export const OUT_OF_STOCK_ERROR = "OUT_OF_STOCK_ERROR";
export const COUNTRY_LIST_SUCCESS = "COUNTRY_LIST_SUCCESS";
export const COUNTRY_LIST_START = "COUNTRY_LIST_START";
export const COUNTRY_LIST_ERROR = "COUNTRY_LIST_ERROR";

export const SAVE_FORM_COUNT_SUCCESS = "SAVE_FORM_COUNT_SUCCESS";
export const SAVE_FORM_COUNT_START = "SAVE_FORM_COUNT_START";
export const SAVE_FORM_COUNT_ERROR = "SAVE_FORM_COUNT_ERROR";
export const CLEAR_PINCODE_VALUE = "CLEAR_PINCODE_VALUE";

export const ON_LOG_OUT_EMPTY_CART="ON_LOG_OUT_EMPTY_CART"